import React from 'react';
import * as styles from './detailedCurriculum.module.scss';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import { LEAD_GEN_NAVIGATION } from '@src/constants/LeadGenerationConstants/index';
import useRequestCallback from './useRequestCallback';

const PageHeader = () => {
  const onSubmitPageOne = useRequestCallback();
  return (
    <header className={styles.top}>
      <div className={styles.wrap}>
        <a href="https://www.crio.do/">
          <img
            src="https://www.crio.do/static/5ac1a39f9eebf6fe904e14069500353e/63cb2/Crio_Dark.png"
            alt="Crio.Do"
          />
        </a>
        <LeadGenerationButton
          text="Talk to an Advisor"
          isOnePageForm
          formHeading="Request Callback"
          pageOneButtonText="Call me back"
          onSubmitPageOne={onSubmitPageOne}
          buttonLocation={LEAD_GEN_NAVIGATION}
          className="h-auto w-auto shrink-0 rounded-xl px-[22px] py-3 text-[15px] shadow-none hover:shadow-none"
        />
      </div>
    </header>
  );
};

export default PageHeader;
